export enum ColumnAlign {
    LEFT,
    MEDIUM,
    RIGHT,
}

export type RowID = [number, number];
